module.exports = __webpack_public_path__ + "static/media/card-pack.d376957b.svg";